import React, { useEffect } from "react";
import Images from "../../images";
import { connect } from "react-redux";
function EmptyScreen(props) {
  const { imageAnime, emptyMessage } = props;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={imageAnime}
        alt="logo"
        style={{
          width: "200px",
          height: "200px",
          objectFit: "contain",
          justifyContent: "center",
          opacity: 0.75,
        }}
      />
      {/* <p className="empty-heading">OOPS!</p> */}
      <p
        className="empty-label"
        style={{
          justifyContent: "center",
        }}
      >
        {emptyMessage}
      </p>
    </div>
  );
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmptyScreen);
